var $document = jQuery(document);
var $window = $document.find('window');
var $body = $document.find('body');
var $header = $document.find('#header');
var site_template = '/local/templates/wide_2019';
// --------------------
// События и прочее
// --------------------
BX.ready(function () {
    if (window.location.hash) {
        if (BX.type.isDomNode(BX(window.location.hash.replace(/#/g, '')))) {
            BX(window.location.hash.replace(/#/g, '')).click(true);
        } else {
            // подсветка элемента
            /* if (window.location.hash) {
                var hash = window.location.hash.split('/');
                if (hash[0] == "#" + this.product.id && this.visual.ID && BX(this.visual.ID)) {
                    // скролл к элементу
                    var item = BX(this.visual.ID);
                    BX.addClass(item, 'color-pulse');
                    var removePulse = function (event) {
                        BX.removeClass(item, 'color-pulse');
                    };
                    document.addEventListener('keydown', removePulse, false);
                    document.addEventListener('click', removePulse, false);
                    setTimeout(function () {
                        // console.log(item);
                        item.scrollIntoView({
                            block: "center",
                            behavior: "smooth"
                        });
                        // BX.scrollToNode(item);
                    }, 100, item);
                } else if (this.offers) {
                    // скролл к sku
                    var selectOffer;
                    var offerNum;
                    this.offers.forEach(function (offer, Num) {
                        if (hash[0] == '#' + offer.ID) {
                            selectOffer = offer;
                            offerNum = Num;
                        }
                    });
                    if (offerNum != null && this.offers[offerNum] != undefined) {
                        this.offerNum = offerNum;
                    }
                    if (selectOffer && selectOffer.VISUAL.ID && BX(selectOffer.VISUAL.ID)) {
                        BX.addClass(selectOffer.VISUAL.ID, 'color-pulse');
                        var removePulse = function (event) {
                            BX.removeClass(selectOffer.VISUAL.ID, 'color-pulse');
                        };
                        document.addEventListener('keydown', removePulse, false);
                        document.addEventListener('click', removePulse, false);
                        setTimeout(function () {
                            // console.log(selectOffer);
                            BX(selectOffer.VISUAL.ID).scrollIntoView({
                                block: "end",
                                behavior: "smooth"
                            });
                            // BX(selectOffer.VISUAL.ID).scrollIntoView({block: "center", behavior: "smooth"});
                            // BX.scrollToNode(selectOffer.VISUAL.ID);
                        }, 100, selectOffer);
                    }
                }
                // this.setAnalyticsDataLayer('detail');
            } */
        }
    }
})
if (window.frameCacheVars !== undefined) { // вставка для отработки композита
    // ленивая загрузка фото
    jQuery(window).lazyLoadXT({
        edgeY: 100,
        srcAttr: 'data-src',
        visibleOnly: true,
        forceLoad: false,
    });
    let $gallery = $document.find(".fancybox");
    gallery_init($gallery);
    BX.addCustomEvent("onFrameDataRequestFail", function (response) {
        jQuery(window).lazyLoadXT({
            edgeY: 100,
            srcAttr: 'data-src',
            visibleOnly: true,
            forceLoad: false,
        });
        console.log("onFrameDataRequestFail");
        console.log(response);
        /*
         response.error = true
         response.reason - причина ошибки
         [response.url] - адрес запрашиваемой страницы
         [response.xhr] - объект XMLHttpRequest
         [response.status] - код ответа сервера
         [response.response] - ответ сервера
          window.location = "/some/url/?ncc=1";
          */
        BX.UI.Notification.Center.notify({
            content: "Ошибка чтения страницы (" + response.reason + ")",
            position: "bottom-right",
            autoHideDelay: 5000,
            closeButton: true,
            category: "onFrameDataRequestFail",
            actions: [{
                title: "Обновить страницу (1сек)",
                events: {
                    click: BX.delegate(function (event, balloon, action) {
                        balloon.close();
                        window.location.reload();
                    }, this),
                }
            }]
        });
        if (response.error == true) {
            setTimeout(function () {
                BX.clearCache();
                window.location.reload();
            }, 1000);
        } else if (response.error == true) {
            if (0) BX.PopupWindowManager.create("onFrameDataRequestFail", null, {
                width: 200, // ширина окна
                content: '<div class="d-flex justify-content-center"><div class="alert alert-danger">' + (response.reason) + '</div></div>',
                closeIcon: {
                    right: "20px",
                    top: "10px"
                },
                titleBar: {
                    content: BX.create("span", {
                        html: '<h1 class="h4 py-2 text-center">Ошибка загрузки данных</h1>',
                        'props': {
                            'className': 'window-title-bar'
                        }
                    })
                },
                zIndex: 0,
                offsetLeft: 0,
                offsetTop: 0,
                draggable: {
                    restrict: false
                },
                closeByEsc: true, // закрытие окна по esc
                // darkMode: true,
                // lightShadow : true,
                // overlay: {backgroundColor: 'black', opacity: '80' },
                overlay: true,
                autoHide: true,
                /* buttons: [
                    new BX.PopupWindowButton({
                        text: "Сохранить" ,
                        className: "popup-window-button-accept" ,
                        events: {click: function(){
                            console.log(this);
                            console.log(window.PopupWindowManagerAnalogs[uniq_id]);
                            jQuery(window.PopupWindowManagerAnalogs[uniq_id].contentContainer).find("#item-analogs").find("input[name='quantity']");
                            this.popupWindow.close();
                        }}
                    }),
                    new BX.PopupWindowButton({
                        text: "Отменить подбор" ,
                        className: "webform-button-link-cancel" ,
                        events: {click: function(){
                            console.log(this);
                            console.log(window.PopupWindowManagerAnalogs[uniq_id]);
                            this.popupWindow.close();
                        }}
                    })
                ] */
            }).show();
        }
    });
}
var widget = null;
window.addEventListener('onBitrixLiveChat', function (event) {
    widget = event.detail.widget;
    // Установка дополнительных данных (публикуется при начале новой сессии, расширенный формат)
    var data = getDataForChat();
    if (Object.keys(data).length === 0 && data.constructor === Object) {
        widget.setCustomData(data);
    }
});

export function getDataForChat() {
    var data = {};
    if (typeof userStore != "undefined") {
        var user = userStore.getters.user;
        var contragent = user.ACTIVE_CONTRAGENT;
        var basket = user.BASKETS[user.BASKET_ID];
        if (user.LOGIN) {
            if (user.NAME) {
                data.USER = {
                    "NAME": user.NAME + ' ' + user.LAST_NAME,
                    // "AVATAR": "http://files.shelenkov.com/images/avatar-ivanov.jpg",
                }
            };
        }
        if (contragent == Object && basket == Object) {
            data.GRID = [{
                "NAME": "E-mail/Login",
                "VALUE": user.EMAIL + '/' + user.LOGIN,
                "DISPLAY": "LINE",
            },
            {
                "NAME": "Код клиента",
                "VALUE": user.XML_ID,
                "COLOR": "#ff0000",
                "DISPLAY": "LINE"
            },
            {
                "NAME": "Контрагент",
                "VALUE": contragent.NAME,
                "COLOR": "#ff0000",
                "DISPLAY": "LINE"
            },
            {
                "NAME": "Корзина",
                "VALUE": basket.ACCOUNT_NUMBER + '(на сумму ' + basket.SUMM_PRICE + ')',
                "COLOR": "#ff0000",
                "DISPLAY": "LINE"
            },
            {
                "NAME": "Сайт",
                "VALUE": location.hostname,
                "DISPLAY": "LINE"
            },
            {
                "NAME": "Страница",
                "VALUE": "[url=" + location.href + "]" + (document.title || location.href) + "[/url]",
                "DISPLAY": "LINE"
            },
            ]
        };
    }
    return data;
};
jQuery(function ($) {
    $document = jQuery(document);
    $window = $document.find('window');
    $body = $document.find('body');
    $header = $document.find('#header');
    $document = jQuery(document);
    $header = $document.find('#header');
    $document.find('[data-toggle="tooltip"]').tooltip();
    //
    let $wows = $document.find(".wow");
    if ($wows !== undefined && $wows.length) {
        if (typeof WOW !== "function") {
            jQuery.getStylesheet = function (href) {
                jQuery('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: href
                }).appendTo('head');
            }
            jQuery.when(jQuery.getStylesheet(site_template + "/plugins/animate.min.css"), jQuery.getScript({
                url: site_template + "/plugins/wow.min.js",
                cache: true
            }))
                .then(function () {
                    new WOW().init();
                }, function (jqxhr, settings, exception) {
                    console.log("animation fail");
                });
        } else {
            try {
                new WOW().init();
            } catch (error) {
                console.log("WOW error");
                console.log(error);
            }
        }
    }
    let $gallery = $document.find(".fancybox");
    if ($gallery.length) {
        gallery_init($gallery);
    }

    // Лэйбл с количеством найденного товара появляется рядом с выбранным брендом
    $document.find("#modef").detach().appendTo($document.find(".bx-filter-container-modef"));
    $document.on("click", ".smartfilter .bx-filter-param-label", function (event) {
        $document.find(".bx-filter-container-modef").detach().appendTo(this);
        $document.find("#modef").addClass("modef-apply-new-style");
        $document.find("#modef #modef_num").prepend('<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>');
    })
    if ($body.hasClass("sidebar-collapsed-mode")
        || location.pathname == '/personal/order/') {
        $document.find("aside#sidebar").addClass("col"); //, article#body
        $body.addClass("sidebar-collapsed-mode");
    }
    $document.on("click", "#desktop_menu_nav_button", function (e) {
        $body.toggleClass("sidebar-collapsed-mode");
        if ($body.hasClass("sidebar-collapsed-mode")) BX.userOptions.save("bitrix_sidebar", "my_sidebar", "sidebar-collapsed", "sidebar-collapsed-mode");
        else BX.userOptions.save("bitrix_sidebar", "my_sidebar", "sidebar-collapsed", "");
        $document.find("aside#sidebar").toggleClass("col"); //, article#body

    });

    var timers_show = [];
    var timers_hide = [];
    jQuery(document).on('mouseenter', '.sidebar-collapsed-mode .sidebar_wrap', function (e) {
        clearTimeout(timers_hide["sidebar_wrap"]);
        clearTimeout(timers_show["sidebar_wrap"]);
        timers_show["sidebar_wrap"] = setTimeout(function (tmpthis) {
            $body.addClass('sidebar-sliding-opening-mode').addClass('sidebar-sliding-mode').removeClass('sidebar-sliding-opening-mode');
            $document.find("aside#sidebar").css({
                "height": $document.find("aside#sidebar .sidebar_wrap").height()
            });
        }, 1500, jQuery(this));
    });
    jQuery(document).on('mouseleave', '.sidebar-collapsed-mode .sidebar_wrap', function (e) {
        clearTimeout(timers_hide["sidebar_wrap"]);
        clearTimeout(timers_show["sidebar_wrap"]);
        timers_hide["sidebar_wrap"] = setTimeout(function (tmpthis) {
            $body.addClass('sidebar-sliding-closing-mode').removeClass('sidebar-sliding-mode').removeClass('sidebar-sliding-closing-mode');
            $document.find("aside#sidebar").css({
                "height": "unset"
            });
        }, 500, jQuery(this));
    });

    // Фиксированное header
    if ($header.length) {
        $header.css("height", $header.outerHeight(true));
        document.addEventListener('scroll', function (e) {
            if ((!isMobile.any() || screenOrientation() == 'portrait')) {
                $header.css("height", $header.outerHeight(true));
                let scrollTop = jQuery(window).scrollTop(),
                    scroll_picca = $header.offset().top;
                if (scrollTop > scroll_picca) {
                    $header.addClass("fixed");
                } else {
                    $header.removeClass("fixed");
                }
                /*// если докрутил до низа страницы
                if(jQuery(window).scrollTop()+jQuery(window).height()>=jQuery(document).height()){
                    jQuery(".bottom_float_menu").hide();
                }*/
            }
        }, {
            passive: true
        });
    };
    // Фиксированные хебные крошки
    var $navigation = jQuery('#navigation');
    if ($navigation.length) {
        // $navigation.css("height",$navigation.outerHeight(true)).children(".bx-breadcrumb").css("top",$header.outerHeight(true));
        var scroll_picca = $navigation.offset().top;
        $navigation.css('width', $navigation.outerWidth(true));
        document.addEventListener('scroll', function (e) {
            if ((!isMobile.any() || screenOrientation() == 'portrait')) {
                let scrollTop = jQuery(window).scrollTop();
                // проверка на докрутку до определенного элемента
                // console.log((jQuery(window).scrollTop()+window.innerHeight)+"<"+scroll_picca) ;// выводим в консоль смещение  элемента пицца
                //если мы докрутили до нужного элемента
                if (scrollTop > scroll_picca - 5) {
                    // создаем эффекты и анимацию
                    // $navigation.addClass("fixed").css("height",$navigation.outerHeight(true)).children(".bx-breadcrumb").css("top",$header.find("#fixed-header").outerHeight(true));
                    $navigation.addClass("fixed").css({
                        "height": $navigation.outerHeight(true),
                        "top": $header.find("#fixed-header").outerHeight(true)
                    });
                } else {
                    // $navigation.removeClass("fixed").css("height",'').children(".bx-breadcrumb").css("top",'');
                    $navigation.removeClass("fixed").css({
                        "height": '',
                        "top": ''
                    });
                }
            }
        }, {
            passive: true
        });
    };
    // ленивая загрузка фото
    if (!!$.prototype.lazyLoadXT) {
        jQuery(window).lazyLoadXT({
            edgeY: 100,
            srcAttr: 'data-src',
            visibleOnly: true,
            forceLoad: false,
        });
    }
    $document.on("click", ".expand", function () {
        var $that = jQuery(this);
        if ($that.hasClass("expanded")) {
            $that.toggleClass("expanded").attr("aria-expanded", "false").css({
                "overflow": "hidden",
                "height": $that.attr("data-height"),
                "min-width": $that.attr("data-width")
            });
        } else {
            $that.toggleClass("expanded").attr("aria-expanded", "true").attr({
                "data-width": $that.outerWidth(),
                "data-height": $that.outerHeight()
            }).css({
                "display": "inline-block",
                "overflow": "hidden",
                "height": "auto",
                "min-width": "auto"
            });
        }
    });
    $document.on("click", ".offers-items-id .collapse-click", function () {
        var $that = jQuery(this);
        setTimeout(function () {
            if (!$that.hasClass(".collapsed")) {
                $that.parents(".table-offers-list").parent().animate({
                    scrollTop: parseInt($that.parents(".tbody").position().top)
                }, 100);
            }
        }, 300);
    });
    $document.on("focus", "input[name='quantity']", function () {
        jQuery(this).parents("tr").addClass("selected");
    });
    $document.on("blur", "input[name='quantity']", function () {
        jQuery(this).parents("tr").removeClass("selected");
    });
    // клик по таблице переводить в input
    $document.on('click', '.catalog-item-offer .tbody > div', function (event) {
        if (event.target == this) {
            var $inputNode = jQuery(this).parent().find(".product-item-amount-field")[0];
            if ($inputNode != undefined) {
                $inputNode.focus();
                $inputNode.select();
            }
        }
    });
    $document.on('click', '.product-item-amount-field', function (event) {
        if (event.target == this) {
            if (jQuery(this).val() != '') {
                jQuery(this).focus();
                jQuery(this).select();
            }
        }
    });
    jQuery("body").on('focus','.product-item-amount-field', function (e) {
        $(this).attr('autocomplete', 'off');
        $(this).attr('autocapitalize', 'off');
        $(this).attr('autocorrect', 'off');
        $(this).attr('spellcheck', 'false');
        jQuery(this).select();
    });
    // проставляет класс zoom по клику
    // TODO унифицировать функцию
    $document.on("click", ".zoome", function (e) {
        var $that = jQuery(this);
        jQuery('.product-item-small-card.variant-1').css('z-index', false);
        jQuery('.product-item-image-original').not($that).removeClass('zoom');
        $that.parents('.product-item-small-card.variant-1').css('z-index', '2');
        $that.toggleClass('zoom');
    });
    $document.on('click', '.collapse-click[data-toggle="collapse"]', function () {
        if (!!$.prototype.lazyLoadXT) {
            jQuery(window).lazyLoadXT();
        }
        var $img = jQuery(jQuery(this).data('target')).find("img[data-src]");
        if (!$img.length) {
            $img = jQuery(this).find("img[data-src]");
        }
        if ($img.length) {
            $img.each(function () {
                jQuery(this).attr('src', jQuery(this).attr('data-src'));
            });
        }
    });
    $document.on('mouseover', '.product-item-container', function () {
        if (!!$.prototype.lazyLoadXT) {
            jQuery(window).lazyLoadXT();
        }
    });
    $document.on('click', 'a[href^="tel:"],a[href^="callto:"]', function (e) {
        if (!isMobile.any()) {
            if (isBrowser.any() != 'chrome') {
                try {
                    var phone = jQuery(this).attr('href').replace(/^tel:/, '');
                    buferCopy(phone);
                    alert("Ваш браузер не поддерживает вызовы по телефону. Номер скопирован в буфер обмена.");
                } catch (error) {
                    alert("Ваш браузер не поддерживает вызовы по телефону.");
                };
                e.preventDefault();
                return false;
            } else {
                jQuery(this).attr('href',
                    jQuery(this).attr('href').replace(/^tel:/, 'callto:'));
            }
        }
    });
    if(typeof WTN !== 'undefined') {
        WTN.deviceInfo().then(function(value){
            if(value.appId == 'ru.fit24.app') {
                jQuery('.searchtitle-btn-barcode-wrap').removeClass('d-none');
            }
        });
        $document.on('click', '.searchtitle-btn-barcode', function (e) {
            const { Format, BarcodeScan } = WTN.Barcode;
            BarcodeScan({
                formats: Format.ALL_FORMATS, // optional
                onBarcodeSearch: (value) => {
                    if(value.substr(0, 17) == 'https://fit24.ru/') {
                        document.location.assign(value);
                    } else if(value != '' && value != 'Canceled' && value.substr(0, 7) != 'Waiting') {
                        jQuery('.bx-searchtitle input[name="q"]').val(value).parents('form').submit();
                    }
                },
            });
        });
    }
});
/*
// --------------------
// Функции
// --------------------
*/
// слайдер в меню
export function slideBlock(index) {
    let elem = jQuery('.' + index);
    if (elem.css("display") == 'block') {
        $.post("/ajax/js_to_session.php", {
            'block': index,
            'display': 'none'
        }, function (result) {
            //alert(result);
        });
    } else {
        $.post("/ajax/js_to_session.php", {
            'block': index,
            'display': 'block'
        }, function (result) {
            //alert(result);
        });
    }
    elem.slideToggle(400, function () {
        if (jQuery("aside#sidebar .sidebar_wrap").length) jQuery("aside#sidebar").css({
            "height": jQuery("aside#sidebar .sidebar_wrap").height()
        });
    });

}
// копирование в буфер
export function buferCopy(str) {
    var tmp = document.createElement('INPUT'), // Создаём новый текстовой input
        focus = document.activeElement; // Получаем ссылку на элемент в фокусе (чтобы не терять фокус)
    tmp.value = str; // Временному input вставляем текст для копирования
    document.body.appendChild(tmp); // Вставляем input в DOM
    try {
        tmp.select(); // Выделяем весь текст в input
        document.execCommand('copy'); // Магия! Копирует в буфер выделенный текст (см. команду выше)
        document.body.removeChild(tmp); // Удаляем временный input
        focus.focus(); // Возвращаем фокус туда, где был
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}
// Динамическая подгрузка CSS
jQuery.getStylesheet = function (href) {
    jQuery('<link/>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: href
    }).appendTo('head');
}
// инициализация галлереи
export function gallery_init(gallery, galleryClass, fancyboxParam) {
    if (typeof fancybox !== "function") {
        try {
            jQuery.getStylesheet = function (href) {
                jQuery('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: href
                }).appendTo('head');
            }
            jQuery.when(jQuery.getStylesheet(site_template + "/plugins/fancybox/jquery.fancybox.css"), jQuery.getScript({
                url: site_template + "/plugins/fancybox/jquery.fancybox.js",
                cache: true
            }))
                .then(function () {
                    console.log("fancybox load");
                }, function (jqxhr, settings, exception) {
                    console.log("fancybox fail");
                });
            if ($.fancybox != undefined) {
                $.fancybox.defaults.hash = false;
                $.fancybox.defaults.clickContent = 'close';
            }
            let $gallery = gallery || $document.find(".gallery");
            fancyboxParam = fancyboxParam || {
                "max-width": "80%",
                "max-height": "80%",
                'width': "1024px",
                "animationEffect": "fade",
                /*'autoSize' : false,*/
                iframe: {
                    css: {
                        preload: true,
                        // width : '80%',
                        // height : '80%'
                    }
                },
                hash: null,
                // protect: true,
                buttons: ["zoom", "share", "slideShow", "fullScreen", /*"download","thumbs",*/ "close"],
            }; //http://fancyapps.com/fancybox/3/docs/#options
            $gallery.each(function () {
                var $img = jQuery(this);
                var fancyboxClass = $img.data("fancybox-class");
                $img.attr('data-fancybox-class', null);
                fancyboxClass = fancyboxClass || galleryClass || "gallery";
                $img_warp = $img.parent();
                if (!$img.parent().is("a")) $img_warp = $img.wrap('<a></a>').parent();
                $img_warp
                    .attr('data-caption', $img.attr("title"))
                    .attr('data-fancybox', fancyboxClass)
                    .attr('href', $img.data("big-src") || $img.attr("src"))
                    .attr('title', $img.attr("title"))
                    .css('cursor', "pointer");
            });
        } catch (error) {
            console.debug(error);
        }
    }
}
// TODO допилить до универсального функционала
export function toggleMobileWindow(target, type) {
    var MobileWindowOpened = false;
    switch (type) {
        case 'menu':
            BX.removeClass(BX("personal_menu_nav_button"), 'MobileWindowOpened');
            BX.removeClass(BX(BX("personal_menu_nav_button").dataset['target'].slice(1)), 'show');
            BX.toggleClass(BX('mobile_menu_nav'), 'fixed');
            BX.toggleClass(BX(target), 'MobileWindowOpened');
            MobileWindowOpened = BX.hasClass(BX(target), 'MobileWindowOpened');
            break;
        case 'personal':
            BX.removeClass(BX('mobile_menu_nav_button'), 'MobileWindowOpened');
            BX.removeClass(BX(BX("mobile_menu_nav_button").dataset['target'].slice(1)), 'show');
            BX.removeClass(BX.findChild(BX("mobile_menu_nav_button"), {
                className: "ham"
            }), 'active');
            BX.removeClass(BX('mobile_menu_nav'), 'fixed');
            BX.toggleClass(BX(target), 'MobileWindowOpened');
            MobileWindowOpened = BX.hasClass(BX(target), 'MobileWindowOpened');
            break;
        default:
            break;
    }
    if (!MobileWindowOpened) {
        BX.removeClass(document.body, 'side-panel-disable-scrollbar');
        BX.removeClass(document.documentElement, 'side-panel-disable-scrollbar');
    } else {
        BX.addClass(document.body, 'side-panel-disable-scrollbar');
        BX.addClass(document.body, 'side-panel-disable-scrollbar');
    }
}
// подсветка SKU который в корзине
export function setRowInBasket($selector) {
    jQuery($selector).parents("tr.thead").addClass("in_basket");
}
// убираем подсветку SKU которого больше нет в корзине
export function rmRowInBasket($selector) {
    jQuery($selector).parents("tr.thead").removeClass("in_basket");
}
/**
 * функция, которая по заданному селектору найдет соответствующие ему элементы,
 * которые при этом попадают в видимую область окна
 * @param  {} selector - селектор
 */
export function inWindow(selector) {
    var scrollTop = jQuery(window).scrollTop();
    var windowHeight = jQuery(window).height();
    var $currentEls = jQuery(selector);
    var result = [];
    $currentEls.each(function () {
        var $el = jQuery(this),
            offset = $el.offset();
        console.log($el);
        if (scrollTop <= offset.top && ($el.height() + offset.top) < (scrollTop + windowHeight))
            result.push(this);
    });
    return jQuery(result);
};

// Определяем мобильные
export var isMobile = {
    Android: function () {
        return (/Android/i).test(navigator.userAgent);
    },
    BlackBerry: function () {
        return (/BlackBerry/i).test(navigator.userAgent);
    },
    iOS: function () {
        return (/iPhone|iPad|iPod/i).test(navigator.userAgent);
    },
    Opera: function () {
        return (/Opera Mini/i).test(navigator.userAgent);
    },
    Windows: function () {
        return (/IEMobile/i).test(navigator.userAgent);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
// Определяем браузер
export var isBrowser = {
    any: function () {
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            return "chrome";
        } else if (navigator.userAgent.toLowerCase().indexOf('msie') > -1) {
            return "msie";
        } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            return "firefox";
        } else if (navigator.userAgent.toLowerCase().indexOf("safari") > -1) {
            return "safari";
        } else if (navigator.userAgent.toLowerCase().indexOf("op") > -1) {
            return "op";
        }
        var nav = navigator.userAgent.toLowerCase();
        var iDevices = [
            'ipad',
            'iphone',
            'ipod',
            'android'
        ]
        while (iDevices.length) {
            var device = iDevices.pop();
            if (nav.indexOf(device) > -1) return device;
        }
        return "no-browser";
    },
};

export var screenOrientation = () => {
    let orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
    if (orientation === "landscape-primary") { //"That looks good."
        orientation = 'landscape';
    } else if (orientation === "landscape-secondary") { //"Mmmh... the screen is upside down!"
        orientation = 'landscape';
    } else if (orientation === "portrait-secondary" || orientation === "portrait-primary") { //"Mmmh... you should rotate your device to landscape"
        orientation = 'portrait';
    } else if (orientation === undefined) { //"The orientation API isn't supported in this browser :("
        orientation = 'portrait';
    }
    return orientation
}

// export var isOS = {
//     name: (/(win|mac|linux|sunos|solaris|iphone)/.exec(navigator.platform.toLowerCase()) || [u])[0].replace('sunos', 'solaris')
// };

BX.ready(function () {
    if (BX('support-chat-link')) {
        BX.bind(BX('support-chat-link'), 'click', function () {
            let linkNode = this;
            let support_href = new URL(linkNode.href);
            if (support_href && support_href.searchParams) {
                window.clientid = BX.getCookie('_ym_uid');
                window.userid = BX.getCookie('UserID');
                support_href.searchParams.set('clientid', window.clientid);
                support_href.searchParams.set('userid', window.userid);
                BX.adjust(linkNode, {
                    attrs: {
                        href: support_href
                    }
                });
            }
        });
    }
});

